import type { KeyboardEvent, ReactNode } from 'react'

type Props = {
  eyebrow: ReactNode
  value: ReactNode
  meta?: ReactNode
  metaTone?: 'warning' | 'danger' | 'success' | 'info'
  sub?: ReactNode
  // When set, the whole card becomes a button that opens the matching screen.
  onClick?: () => void
  // Accessible name for the clickable card (falls back to the eyebrow if it's a
  // plain string). Only used when onClick is set.
  ariaLabel?: string
}

export function KpiCard({ eyebrow, value, meta, metaTone, sub, onClick, ariaLabel }: Props) {
  const clickable = !!onClick
  const onKeyDown = clickable
    ? (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick!()
        }
      }
    : undefined
  return (
    <div
      className={clickable ? 'kpi kpi--clickable' : 'kpi'}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-label={clickable ? (ariaLabel ?? (typeof eyebrow === 'string' ? eyebrow : undefined)) : undefined}
    >
      <div className="kpi-eyebrow">{eyebrow}</div>
      <div className="kpi-number">{value}</div>
      {sub && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--fg-3)',
            fontVariantNumeric: 'tabular-nums',
            marginTop: -2,
          }}
        >
          {sub}
        </div>
      )}
      {meta && <div className={`kpi-meta ${metaTone ?? ''}`}>{meta}</div>}
    </div>
  )
}
